module.exports = __webpack_public_path__ + "static/media/Pin.1ec40b7a.svg";